export default __webpack_public_path__ + "static/media/feature3.2be181ad.svg";